module.exports = __webpack_public_path__ + "img/img5.3719a392.jpg";